import { Box, IconButton, Typography } from '@mui/material'
import { DinamicForm } from '../../../../../../components/dinamicForm'
import { icons } from '../../../../../../utils/icons'
import { ObjectGeneric, onChange } from '../../../../../../utils/types/generals'
import { Props } from './props'
import { useStyles } from './styles'
import { memo, useEffect, useState } from 'react'
import { handleErrors } from '../../pages/methods/methods'
import { useTranslation } from 'react-i18next'
import { CustomPaper } from '../../../../../../components/CustomPaper'
import { InputModel } from '../../../../../../utils/types'

const Form = ({ addOption, color, externalData }: Props) => {
  const styles = useStyles(color)
  const [allErrors, setAllErrors] = useState<ObjectGeneric>({})
  const [data, setData] = useState<ObjectGeneric>(externalData ?? {})
  const { t } = useTranslation()


  const crudChange: onChange = (e): void => {
    const { name, value } = e?.target
    let body = { ...data }

    body = {
      ...body,
      [name]: value,
    }

    setData(body)
    setAllErrors(handleErrors(body, t))
  }

  const option = {
    description: {
      label: 'general.tags.description',
      translate: true,
      name: 'description',
      rest: {
        type: 'alphaNumeric',
        multiline: true,
        rows: 3,
        maxRows: 3,
        placeholder: 'Ingrese la descripción'
      },
      validate: {
        required: true,
      },
      value: null,
      size: {
        xs: 12,
      },
    },
    iconUrl: {
      label: 'general.tags.file',
      translate: true,
      name: 'iconUrl',
      type: 'simple-file',
      value: null,
      rest: {
        accept: '.png,.jpg,.jpeg',
        simpleFile: true,
      },
      size: {
        xs: 12,
        lg: 8,
        md: 8,
        sm: 12,
        xl: 8,
      },
      wrapChildren: ({ children, id }) => {
        return (
          <Box sx={styles.containerChildren}>
            <Box sx={styles.children}>{children}</Box>
            <Box sx={styles.optionsAdd(!data?.description)}>
              <IconButton
                className="add"
                onClick={() => {
                  addOption({description:data.description,icon:data.iconUrl,id:Math.floor(Math.random() * 10000)}, data?.id);
                  setData({})
                }}
                disabled={!data?.description}
              >
                {icons('add')}
              </IconButton>
            </Box>
          </Box>
        );
      }
    },
  } as { [x: string]: InputModel }

  useEffect(() => {
    setData(externalData ?? {})
  }, [externalData])


  return (
    <CustomPaper elevation={3} sx={styles.containerItems}>
      <Typography variant="title_grey" fontWeight={'normal'}>{t('optionGroup.title.addOptions')}</Typography>

      <DinamicForm
        input={Object.values(option)}
        values={data}
        onChange={(e) => {
          crudChange(e)
        }}
        errors={allErrors}
      />
    </CustomPaper>
  )
}

export default memo(Form)
